module.exports = __webpack_public_path__ + "img/d4-active.31a11a60.png";